










































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import axios from 'axios';
import moment, { Moment } from 'moment';
import { dateTime } from '@/util/adapter';
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
import storage from 'baimahu/storage';
import {
  StatusEnum,
  TypeEnum,
  PostageTypeEnum,
  STOCK_PATTERN,
} from './constant';
const uuidv4 = require('uuid/v4');
const clean = require('bmh/clean-empty-obj');
const { VUE_APP_FCAPI: FCAPI, VUE_APP_API } = process.env;
const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};

interface Ware {
  category_id: number[];
  type: TypeEnum;
  type_secondary: string;
  need_express: string;
  name: string;
  share_description: string;
  service_list: SimpleArrayItem[];
  carousel_list: string[];
  detail_list: string[];
  poster: string[];
  // 引流
  guide_visible: boolean;
  guide_text: string;
  guide_wechat_qrcode: string;
  guide_wechat_id: string;
  // 价格库存
  price: number | '';
  unit: string;
  stock: number | '';
  postage_type: PostageTypeEnum;
  postage: number | '';
  cost: number | ''; // 成本
  // 分销设置
  bonus: number | '';
  stock_pattern: number;
  commission_one_self: any | '';
  commission_one_two: any | '';
  commission_two: any | '';
  // 发布设置
  status: StatusEnum;
  online_time: Moment | undefined;
  sort: number;
  index_show: number;
}

interface Preview {
  visible: boolean;
  url: string;
}

interface Validator {
  field: string;
  validate: (value: any, ware: Ware) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}

function getSimpleArrayItem(value: string = ''): SimpleArrayItem {
  return {
    _key: uuidv4(),
    value,
  };
}

function getWare(remote?: any): Ware {
  remote = remote || {};
  const service_list = (remote.service_caption_list || []).map((value: string) => getSimpleArrayItem(value));
  const remote_guide_data = remote.marketing_info_json || {};
  /* 页面设置 */
  const remote_poster = remote.share_img_url;
  /* 引流设置 */
  const guide_data = {
    guide_visible: true,
    guide_text: '',
    guide_wechat_qrcode: '',
    guide_wechat_id: '',
  };
  if (
    remote.id &&
    ((remote_guide_data instanceof Array && remote_guide_data.length === 0) ||
      (Object.prototype.toString.call(remote_guide_data) === '[object Object]' &&
        Object.keys(remote_guide_data).length === 0))
  ) {
    guide_data.guide_visible = false;
  } else {
    guide_data.guide_text = remote_guide_data.copywriting || '';
    guide_data.guide_wechat_qrcode = remote_guide_data.qrcode_url || '';
    guide_data.guide_wechat_id = remote_guide_data.wechat_id || '';
  }
  /* 发布设置 */
  const remote_online_time = remote.up_time;
  let status = StatusEnum.online;
  let online_time;
  if (remote_online_time === undefined) {
    // 默认立即上线
    status = StatusEnum.online;
  } else if (remote_online_time === '') {
    status = StatusEnum.stock;
  } else {
    status = StatusEnum.out;
    online_time = moment(remote.up_time || undefined);
  }
  let category_ids: any = [];
  if (remote.id && remote.category_id_second === 0) {
    if (remote.category_id_first !== 0) {
      category_ids = [remote.category_id_first];
    }
  } else if (remote.id && remote.category_id_second !== 0) {
    category_ids = [remote.category_id_first, remote.category_id_second];
  }

  /* 价格库存 */
  const remote_postage = remote.express_price;
  return {
    category_id: category_ids,
    type: remote.type,
    type_secondary: remote.type_secondary || 0,
    need_express: remote.need_express,
    name: remote.name || '',
    share_description: remote.moments_caption || '',
    service_list: service_list.length === 0 ? [getSimpleArrayItem()] : service_list,
    carousel_list: remote.banner_url_list || [],
    detail_list: remote.detail_url_list || [],
    // poster:
    //   remote_poster instanceof Array
    //     ? remote_poster[0] || ''
    //     : remote_poster
    //     ? remote_poster
    //     : '',
    poster: remote_poster || [],
    ...guide_data,
    price: remote.price ? remote.price / 100 : 0,
    unit: remote.unit || '',
    stock: remote.current_stock || '',
    postage_type: remote_postage === 0 || remote_postage === undefined ? PostageTypeEnum.free : PostageTypeEnum.cost,
    postage: remote_postage ? remote_postage / 100 : '',
    cost: remote.product_cost ? remote.product_cost / 100 : '',
    bonus: remote.commission_rule ? remote.commission_rule / 100 : '',
    stock_pattern: remote.stock_pattern || 1,
    commission_one_self: remote.commission_one_self,
    commission_one_two: remote.commission_one_two,
    commission_two: remote.commission_two,
    status,
    online_time,
    sort: remote.sort || 1,
    index_show: remote.index_show || 1,
  };
}

function getPreview(url: string = '', visible: boolean = false): Preview {
  return {
    url,
    visible,
  };
}

function getRemoteGuideData(ware: Ware) {
  if (!ware.guide_visible) {
    return {};
  }
  return {
    copywriting: ware.guide_text,
    qrcode_url: ware.guide_wechat_qrcode,
    wechat_id: ware.guide_wechat_id,
  };
}

function getRemoteOnlineTime(ware: Ware) {
  return {
    [StatusEnum.online]: dateTime(moment()),
    [StatusEnum.out]: dateTime(moment(ware.online_time)),
    [StatusEnum.stock]: '',
  }[ware.status];
}

function getRemoteServiceList(ware: Ware) {
  const set = new Set(
    ware.service_list.map((service: SimpleArrayItem): string => service.value.trim()).filter((str: string) => str)
  );
  return Array.from(set);
}

function getPostage(ware: Ware) {
  if (ware.type === TypeEnum.real) {
    return ware.postage_type === PostageTypeEnum.free ? 0 : ware.postage;
  }
  return undefined;
}

function generateDetailList(specification: any, children: any[]) {
  // 选择属性后，生成明细需要的数据结构
  return specification.value_list.map((value: any) => {
    let detail = {
      specification_id: specification.id,
      specification_name: specification.text,
      specification_value_id: value.id,
      specification_value_name: value.text,
      children,
    };
    if (!children) {
      detail = Object.assign(detail, {
        id: '',
        price: '',
        stock_num: '',
        cost_price: '',
        sold_num: '',
      });
    }
    return JSON.parse(JSON.stringify(detail));
  });
}

function generateTable(specification_list: any) {
  let temp_list = [];
  for (let i = specification_list.length - 1; i >= 0; i--) {
    const specification = specification_list[i];
    if (specification.value_list.length === 0) {
      continue;
    }
    temp_list = generateDetailList(specification, temp_list.length === 0 ? null : temp_list);
  }
  return temp_list;
}

function getValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'name',
      validate: (value: string): boolean => value.length > 0 && value.length <= NAME_MAX_LENGTH,
      message: `商品名称必填且应不多于${NAME_MAX_LENGTH}个字`,
    },
    {
      field: 'category_id',
      validate: (value: string): boolean => value.length > 0,
      message: '商品分类必选',
    },
    {
      field: 'carousel_list',
      validate: (list: string[]): boolean => list.length > 0 && list.length <= CAROUSEL_MAX_LENGTH,
      message: '轮播图必传且最多上传5张',
    },
    {
      field: 'detail_list',
      validate: (list: string[]): boolean => list.length > 0,
      message: '详情图必传',
    },
    // {
    //   field: 'poster',
    //   validate: (value: string): boolean => !!value,
    //   message: '分享海报必传',
    // },
    {
      field: 'guide_text',
      validate: (value: string, ware: Ware): boolean => {
        if (!ware.guide_visible) {
          return true;
        }
        return value.length > 0 && value.length <= GUIDE_TEXT_MAX_LENGTH;
      },
      message: `引流文案必填且应不多于${GUIDE_TEXT_MAX_LENGTH}个字`,
    },
    {
      field: 'guide_wechat_qrcode',
      validate: (value: string, ware: Ware): boolean => {
        if (!ware.guide_visible) {
          return true;
        }
        return ware.guide_visible && !!value;
      },
      message: '引流微信二维码必传',
    },
    {
      field: 'guide_wechat_id',
      validate: (value: string, ware: Ware): boolean => {
        if (!ware.guide_visible) {
          return true;
        }
        return ware.guide_visible && !!value;
      },
      message: '引流微信号必填',
    },
    {
      field: 'price',
      validate: (value: string): boolean => /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value),
      message: `价格必填且应为最多两位小数的非负数`,
    },
    {
      field: 'unit',
      validate: (value: string): boolean => !!value,
      message: '单位必填',
    },
    {
      field: 'stock',
      validate: (value: string): boolean => /(^[1-9]+\d*$)|(^0$)/.test(value),
      message: `库存必填且应为非负整数`,
    },
    {
      field: 'postage',
      validate: (value: string, ware: Ware): boolean => {
        if (ware.type === TypeEnum.virtual || ware.postage_type === PostageTypeEnum.free) {
          return true;
        }
        return /(^[1-9]\d*(\.\d{1,2})?$)|(^0\.\d{1,2}$)/.test(value);
      },
      message: `邮费应选择免邮或必填且应为最多两位小数的正数`,
    },
    {
      field: 'cost',
      validate: (value: string): boolean => {
        if (!value) {
          return true;
        }
        return /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value);
      },
      message: `成本应为最多两位小数的非负数`,
    },
    {
      field: 'commission_two',
      validate: (value: string): boolean => /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value),
      message: `奖金标准应为最多两位小数的非负数`,
    },
    {
      field: 'commission_one_self',
      validate: (value: string): boolean => /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value),
      message: `奖金标准应为最多两位小数的非负数`,
    },
    {
      field: 'commission_one_two',
      validate: (value: string): boolean => /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value),
      message: `奖金标准应为最多两位小数的非负数`,
    },
    {
      field: 'online_time',
      validate: (value: Moment | undefined, ware: Ware): boolean => ware.status !== StatusEnum.out || !!value,
      message: `自定义上架时间必选`,
    },
    {
      field: 'sort',
      validate: (value: string): boolean => /^[1-9]+\d*$/.test(value),
      message: `排序必填且应为正整数`,
    },
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}

const API = {
  category_list: `${FCAPI}/shang/ware/category`,
  query: `${VUE_APP_API}/qy/ware/detail/query`,
  create: `${VUE_APP_API}/qy/ware/detail/add`,
  update: `${VUE_APP_API}/qy/ware/detail/edit`,
  merchant_config: `${VUE_APP_API}/qy/merchant/account/config`,
  stock_data: `${VUE_APP_API}/qy/user/clerk/ware-stock`,
  attr_data: `${VUE_APP_API}/qy/ware/attribute/index`,
  add_attr: `${VUE_APP_API}/qy/ware/attribute/save`,
};

const UPLOAD_DIR = {
  carousel: 'ware/carousel',
  detail: 'ware/detail',
  poster: 'ware/poster',
  qrcode: 'ware/qrcode',
  attr: 'ware/attr',
};
const CAROUSEL_MAX_LENGTH: number = 5;
const NAME_MAX_LENGTH: number = 40;
const GUIDE_TEXT_MAX_LENGTH: number = 30;

@Component({
  components: {
    MultipleImageUpload,
    SingleImageUpload,
  },
})
export default class WareEdit extends Vue {
  @State('basis') basis!: Business.Basis;

  formItemLayout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };

  TYPE_ENUM = TypeEnum;
  POSTAGE_TYPE_ENUM = PostageTypeEnum;
  STATUS_ENUM = StatusEnum;
  UPLOAD_DIR = UPLOAD_DIR;
  CAROUSEL_MAX_LENGTH: number = CAROUSEL_MAX_LENGTH;
  NAME_MAX_LENGTH: number = NAME_MAX_LENGTH;
  GUIDE_TEXT_MAX_LENGTH: number = GUIDE_TEXT_MAX_LENGTH;
  STOCK_PATTERN = STOCK_PATTERN;
  category_list: any = [];
  loading: boolean = false;
  preview: Preview = getPreview();
  poster_preview: Preview = getPreview();
  poster_qrcode: string = '';
  enable_poster_to_preview: boolean = false;

  is_app_bound: boolean = false;
  is_app_online: boolean = false;
  package_type: number = 0;
  ware: Ware = getWare();
  param_list: any = [];
  validatorMap: { [field: string]: Validator } = getValidatorMap();
  field_watch_list: (() => void)[] = [];
  merchant_config: any = {};
  clerk_stock_data: any = [];
  is_commission_flag: boolean = false;
  merchant_id: any = '';
  attr_list: any = [];
  attr_table: any = [];
  is_show_attr_img: boolean = false;
  is_show_attr_table: boolean = false;
  attr_data: any = [];
  new_value_text: any = '';
  sku_list: any = [];
  sku_attr: any = [];
  is_add_new_attr: boolean = false;
  attr_name_list: any = [];

  get id(): number {
    const id = Number(this.$route.params.id);
    if (Number.isNaN(id)) {
      return 0;
    }
    return id;
  }
  get isNew() {
    return this.id === 0;
  }
  async getCategoryList() {
    const res = await this.$axios.get(API.category_list);
    if (res.data.status === 200) {
      this.category_list = res.data.data;
    }
  }
  @Watch('ware.postage_type')
  onPostageTypeChange(val: PostageTypeEnum) {
    if (val === PostageTypeEnum.free && this.ware.postage) {
      this.ware.postage = '';
    }
  }

  @Watch('ware.postage')
  onPostageChange(val: string) {
    if (val && this.ware.postage_type === PostageTypeEnum.free) {
      this.ware.postage_type = PostageTypeEnum.cost;
    }
  }

  @Watch('ware.status')
  onStatusChange(val: StatusEnum) {
    if (val !== StatusEnum.out && this.ware.online_time) {
      this.ware.online_time = undefined;
    }
  }

  @Watch('ware.online_time')
  onOnlineTimeChange(val: Moment | undefined) {
    if (this.ware.status !== StatusEnum.out && val) {
      this.ware.status = StatusEnum.out;
    }
  }

  @Watch('ware.name')
  onNameChange(val: string, old_val: string) {
    if (val.length > NAME_MAX_LENGTH) {
      this.ware.name = old_val;
    }
  }

  @Watch('ware.guide_text')
  onGuideTextChange(val: string, old_val: string) {
    if (val.length > GUIDE_TEXT_MAX_LENGTH) {
      this.ware.guide_text = old_val;
    }
  }

  onAttrTableInputChange() {
    // 属性明细修改后，更新本地保存的数据
    this.sku_list = this.getSkuList();
  }
  addParam() {
    this.param_list.push({ param: '', value: '' });
  }
  DeleteParam(index: number) {
    this.param_list.splice(index, 1);
  }
  beforeCarouselUpload(file: any, fileList: any[]) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('上传图片大小不能超过2M');
      return false;
    }
    if (this.ware.carousel_list.length + fileList.length > CAROUSEL_MAX_LENGTH) {
      this.$message.error(`最多上传 ${CAROUSEL_MAX_LENGTH} 张`);
      return false;
    }
  }

  commonBeforeUpload(file: any, fileList: any[]) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('上传图片大小不能超过2M');
      return false;
    }
  }

  handleTypeClick(type: TypeEnum) {
    if (!this.isNew) {
      return this.$message.warn('商品创建后，类型不可修改');
    }
    this.ware.type = type;
  }

  addService() {
    if (this.ware.service_list.some((service: any) => !service.value.trim())) {
      return this.$message.warning('请先填写已存在的服务内容');
    }
    this.ware.service_list.push(getSimpleArrayItem());
  }

  handlePreview(url: string) {
    this.preview = getPreview(url, true);
  }

  handlePreviewCancel() {
    this.preview = getPreview();
  }

  handleGuideVisibleChange({ target }: { target: HTMLInputElement }) {
    this.ware.guide_visible = target.checked;
  }

  async handlePosterPreview() {
    this.loading = true;
    try {
      if (this.is_app_online && !this.poster_qrcode) {
        this.poster_qrcode = await this.fetchPosterQrcode(this.id);
      }
    } catch (e) {
      console.error(e);
    }
    this.poster_preview = getPreview(this.ware.poster.join(','), true);
    this.loading = false;
  }

  handlePosterPreviewCancel() {
    this.poster_preview = getPreview();
  }

  async query() {
    this.loading = true;
    const _data = ((await this.$axios.get(`${API.query}?id=${this.id}`)) || {}).data || {};
    this.loading = false;
    if (_data.error) {
      this.$message.error(_data.message);
    }
    if (_data.data.id && _data.data.parameters && _data.data.parameters.length > 0) {
      _data.data.parameters.forEach((item: any) => {
        const o: any = {};
        for (const obj of Object.keys(item)) {
          o.param = obj;
          o.value = item[obj];
        }
        this.param_list.push(o);
      });
    }
    this.ware = getWare(_data.data);
    if (_data.data && _data.data.is_enable_attribute > 0) {
      this.sku_attr = JSON.parse(_data.data.sku_attribute_json);
      this.setAttrList();
      this.is_show_attr_table =
        this.attr_list.length > 0 && this.attr_list[0].value_list.length > 0 && this.attr_list[0].value_list[0].id > 0;
      this.attr_table = generateTable(this.attr_list);
      this.sku_list = _data.data.sku_list;
      this.setSkuAll();
    }
  }

  setAttrList() {
    // 获取接口里的属性字段，遍历后生成前端需要的数据结构
    this.sku_attr.forEach((item: any) => {
      const attr_item: any = {
        id: item.name.id,
        text: item.name.text,
        value_list: [],
        value_data: [],
      };
      item.value.forEach((item_value: any) => {
        attr_item.value_list.push({
          id: item_value.id,
          text: item_value.text,
          image_url: item_value.image_url ? item_value.image_url : '',
          parent_id: item.name.id,
        });
      });
      this.attr_list.push(attr_item);
    });
    this.attr_data.forEach((item: any) => {
      this.attr_list.forEach((item_list: any, index: any) => {
        if (item.id === item_list.id) {
          this.attr_list[index].value_data = item.children;
        }
        item_list.value_list.forEach((item_value: any) => {
          if (item_value.image_url) {
            this.is_show_attr_img = true;
          }
        });
      });
    });
  }

  setSkuAll() {
    // 获取到接口里的sku相关内容，生成前端需要的格式
    this.sku_list.forEach((item_sku: any) => {
      item_sku.detail = JSON.parse(item_sku.detail_json);
      this.attr_table = this.attr_table.map((item_attr_one: any) => {
        if (!item_attr_one.children) {
          if (item_attr_one.specification_value_id === item_sku.detail[0][1].id) {
            item_attr_one.price = item_sku.price / 100;
            item_attr_one.stock_num = item_sku.stock_num;
            item_attr_one.cost_price = item_sku.cost_price / 100;
            item_attr_one.sold_num = item_sku.sold_num;
            item_attr_one.id = item_sku.id ? item_sku.id : 0;
          }
        } else {
          item_attr_one.children = item_attr_one.children.map((item_attr_two: any) => {
            if (!item_attr_two.children) {
              if (
                item_sku.detail[0] &&
                item_attr_one.specification_value_id === item_sku.detail[0][1].id &&
                item_attr_two.specification_value_id === item_sku.detail[1][1].id
              ) {
                item_attr_two.price = item_sku.price / 100;
                item_attr_two.stock_num = item_sku.stock_num;
                item_attr_two.cost_price = item_sku.cost_price / 100;
                item_attr_two.sold_num = item_sku.sold_num;
                item_attr_two.id = item_sku.id ? item_sku.id : 0;
              }
            } else {
              item_attr_two.children = item_attr_two.children.map((item_attr_three: any) => {
                if (
                  item_attr_one.specification_value_id === item_sku.detail[0][1].id &&
                  item_sku.detail[1] &&
                  item_attr_two.specification_value_id === item_sku.detail[1][1].id &&
                  item_attr_three.specification_value_id === item_sku.detail[2][1].id
                ) {
                  item_attr_three.price = item_sku.price / 100;
                  item_attr_three.stock_num = item_sku.stock_num;
                  item_attr_three.cost_price = item_sku.cost_price / 100;
                  item_attr_three.sold_num = item_sku.sold_num;
                  item_attr_three.id = item_sku.id ? item_sku.id : 0;
                }
                return JSON.parse(JSON.stringify(item_attr_three)); // 此写法是为了防止修改一条数据，结果相关的几条数据全部修改
              });
            }
            return JSON.parse(JSON.stringify(item_attr_two)); // 此写法是为了防止修改一条数据，结果相关的几条数据全部修改
          });
        }
        return JSON.parse(JSON.stringify(item_attr_one)); // 此写法是为了防止修改一条数据，结果相关的几条数据全部修改
      });
    });
  }

  validate(field: string) {
    const ware = this.ware as any;
    const is_valid = this.validatorMap[field].validate(ware[field], ware);
    this.validatorMap[field].status = is_valid ? 'success' : 'error';
    this.validatorMap[field].help = is_valid ? '' : this.validatorMap[field].message;
    return is_valid;
  }

  validateCommit() {
    console.log(this.validatorMap);
    if (this.package_type === 2) {
      delete this.validatorMap.detail_list;
    }
    const ware = this.ware as any;
    let is_valid: boolean = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        if (this.is_show_attr_table && (field === 'price' || field === 'stock' || field === 'cost')) {
          is_valid = true;
        } else {
          is_valid = false;
        }
      }
    });
    if (
      Number(ware.commission_one_self) >= ware.price ||
      Number(ware.commission_one_two) >= ware.price ||
      Number(ware.commission_two) >= ware.price ||
      Number(ware.commission_one_two) + Number(ware.commission_two) >= ware.price
    ) {
      this.is_commission_flag = true;
    }
    if (!is_valid) {
      this.$message.error('表单填写有误，请仔细检查');
    }
    return is_valid;
  }

  async create() {
    const params: any = [];
    this.param_list.forEach((item: any) => {
      const obj: any = {};
      obj[item.param] = item.value;
      params.push(obj);
    });
    const ware = this.ware;
    const guide_data = getRemoteGuideData(ware);
    clean(guide_data);
    const online_time = getRemoteOnlineTime(ware);
    const send_data: any = {
      parameters: params,
      category_id_first: ware.category_id[0] ? ware.category_id[0] : 0,
      category_id_second: ware.category_id[1] ? ware.category_id[1] : 0,
      type: ware.type,
      type_secondary: ware.type_secondary,
      need_express: ware.need_express,
      name: ware.name,
      moments_caption: ware.share_description,
      service_caption_list: getRemoteServiceList(ware),
      banner_url_list: ware.carousel_list,
      detail_url_list: ware.detail_list,
      share_img_url: ware.poster,
      price: ware.price,
      unit: ware.unit,
      stock: ware.stock,
      product_cost: ware.cost,
      express_price: getPostage(ware),
      commission_rule: ware.bonus,
      marketing_info_json: JSON.stringify(guide_data),
      up_time: online_time,
      immediately_up: this.ware.status === this.STATUS_ENUM.online ? 1 : 2,
      sort: ware.sort,
      index_show: ware.index_show,
      stock_pattern: ware.stock_pattern,
      commission_one_self: ware.commission_one_self,
      commission_one_two: ware.commission_one_two,
      commission_two: ware.commission_two,
    };
    if (this.is_show_attr_table) {
      this.submitAttrData(send_data);
    } else {
      send_data.enable_attribute = 0;
    }
    clean(send_data);
    const _data = ((await this.$axios.post(API.create, send_data)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    storage.removeItem('ware_first');
    this.$router.push('/ware/list');
  }

  async update() {
    const params: any = [];
    this.param_list.forEach((item: any) => {
      const obj: any = {};
      obj[item.param] = item.value;
      params.push(obj);
    });
    const ware = this.ware;
    const guide_data = getRemoteGuideData(ware);
    clean(guide_data);
    const online_time = getRemoteOnlineTime(ware);
    const send_data: any = {
      parameters: params,
      id: this.id,
      category_id_first: ware.category_id[0] ? ware.category_id[0] : 0,
      category_id_second: ware.category_id[1] ? ware.category_id[1] : 0,
      name: ware.name,
      moments_caption: ware.share_description,
      service_caption_list: getRemoteServiceList(ware),
      banner_url_list: ware.carousel_list,
      detail_url_list: ware.detail_list,
      share_img_url: ware.poster,
      price: ware.price,
      unit: ware.unit,
      stock: ware.stock,
      product_cost: ware.cost,
      express_price: getPostage(ware),
      commission_rule: ware.bonus,
      marketing_info_json: JSON.stringify(guide_data),
      up_time: online_time,
      immediately_up: this.ware.status === this.STATUS_ENUM.online ? 1 : 2,
      sort: ware.sort,
      index_show: ware.index_show,
      stock_pattern: ware.stock_pattern,
      commission_one_self: ware.commission_one_self,
      commission_one_two: ware.commission_one_two,
      commission_two: ware.commission_two,
    };
    if (this.is_show_attr_table) {
      this.submitAttrData(send_data);
    } else {
      send_data.enable_attribute = 0;
    }
    clean(send_data);
    const _data = ((await this.$axios.post(API.update, send_data)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.$router.push('/ware/list');
  }

  submitAttrData(send_data: any) {
    // 提交数据时，将前端的格式转换成后台需要的格式
    send_data.enable_attribute = 1;
    const attr_arr: any = [];
    this.attr_list.forEach((item: any) => {
      const option: any = {
        name: {},
        value: [],
      };
      option.name = {
        id: item.id,
        text: item.text,
      };
      item.value_list.forEach((item_value: any) => {
        if (item.id === item_value.parent_id) {
          option.value.push({
            id: item_value.id,
            text: item_value.text,
            image_url: item_value.image_url,
          });
        }
      });
      attr_arr.push(option);
    });
    send_data.sku_attribute_json = JSON.stringify(attr_arr);
    send_data.sku_list = this.getSkuList(true);
    return send_data;
  }

  getSkuList(is_send_data: boolean = false) {
    // 提交数据时，将前端的格式转换成后台需要的格式。因前后端价格单位不统一的原因，提交给后台的时候为元，更新本地数据时手动乘100
    const attr_detail: any = [];
    this.attr_table.forEach((item: any) => {
      let option: any = {
        id: 0,
        price: '',
        stock_num: '',
        cost_price: '',
        detail_json: [],
      };
      if (!item.children) {
        option = {
          id: item.id,
          price: is_send_data ? item.price : item.price * 100,
          stock_num: item.stock_num,
          cost_price: is_send_data ? item.cost_price : item.cost_price * 100,
        };
        const detail = [];
        detail.push(
          {
            id: item.specification_id,
            text: item.specification_name,
          },
          {
            id: item.specification_value_id,
            text: item.specification_value_name,
          }
        );
        const detail_json = [];
        detail_json.push(detail);
        option.detail_json = JSON.stringify(detail_json);
        attr_detail.push(option);
      } else {
        item.children.forEach((item_two: any) => {
          if (!item_two.children) {
            option = {
              id: item_two.id,
              price: is_send_data ? item_two.price : item_two.price * 100,
              stock_num: item_two.stock_num,
              cost_price: is_send_data ? item_two.cost_price : item_two.cost_price * 100,
            };
            const detail = [];
            detail.push(
              {
                id: item.specification_id,
                text: item.specification_name,
              },
              {
                id: item.specification_value_id,
                text: item.specification_value_name,
              }
            );
            const detail_two = [];
            detail_two.push(
              {
                id: item_two.specification_id,
                text: item_two.specification_name,
              },
              {
                id: item_two.specification_value_id,
                text: item_two.specification_value_name,
              }
            );
            let detail_json: any = [];
            detail_json = [detail, detail_two];
            option.detail_json = JSON.stringify(detail_json);
            attr_detail.push(option);
          } else {
            item_two.children.forEach((item_three: any) => {
              option = {
                id: item_three.id,
                price: is_send_data ? item_three.price : item_three.price * 100,
                stock_num: item_three.stock_num,
                cost_price: is_send_data ? item_three.cost_price : item_three.cost_price * 100,
              };
              const detail = [];
              detail.push(
                {
                  id: item.specification_id,
                  text: item.specification_name,
                },
                {
                  id: item.specification_value_id,
                  text: item.specification_value_name,
                }
              );
              const detail_two = [];
              detail_two.push(
                {
                  id: item_two.specification_id,
                  text: item_two.specification_name,
                },
                {
                  id: item_two.specification_value_id,
                  text: item_two.specification_value_name,
                }
              );
              const detail_three = [];
              detail_three.push(
                {
                  id: item_three.specification_id,
                  text: item_three.specification_name,
                },
                {
                  id: item_three.specification_value_id,
                  text: item_three.specification_value_name,
                }
              );
              let detail_json: any = [];
              detail_json = [detail, detail_two, detail_three];
              option.detail_json = JSON.stringify(detail_json);
              attr_detail.push(option);
            });
          }
        });
      }
    });
    return JSON.parse(JSON.stringify(attr_detail)); // 此写法是为了防止修改一条数据，结果相关的几条数据全部修改
  }

  async commit() {
    if (!this.validateCommit()) {
      return;
    }
    if (this.is_commission_flag) {
      const _this = this;
      this.$confirm({
        title: '单件商品奖励≥商品价格，是否继续提交？',
        onOk() {
          _this.commitDetail();
        },
        onCancel() {
          return;
        },
      });
    } else {
      this.commitDetail();
    }
  }

  async commitDetail() {
    this.loading = true;
    try {
      if (this.isNew) {
        await this.create();
      } else {
        await this.update();
      }
    } catch (e) {
      console.error(e);
    }
    storage.removeItem('ware_type');
    this.loading = false;
  }

  async fetchPosterQrcode(id: number) {
    const _data = ((await axios.get(`${FCAPI}/shang/ware/preview`)) || {}).data || {};
    if (_data.status !== 200) {
      console.error(_data.message);
      return {
        is_app_bound: false,
        is_app_online: false,
      };
    }
    return _data.data;
  }

  async fetchWarePageData(): Promise<Ware.WarePageData> {
    const _data = ((await axios.get(`${FCAPI}/shang/ware/preview`)) || {}).data || {};
    if (_data.status !== 200) {
      console.error(_data.message);
      return {
        is_app_bound: false,
        is_app_online: false,
      };
    }
    return _data.data;
  }

  async getMerchantConfig() {
    const _data = ((await this.$axios.get(API.merchant_config)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.merchant_config = _data.data;
  }

  async getStockData() {
    const _data = ((await this.$axios.get(`${API.stock_data}?ware_id=${this.id}`)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.clerk_stock_data = _data.data;
  }

  async getAttrData(item_id: any, value_item: any, attr_value_item: any) {
    // item_id=>新增属性值返回id，value_item=>当前的属性item, attr_value_item=>属性值item
    const _data = ((await this.$axios.get(`${API.attr_data}?merchant_id=${this.merchant_id}`)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    this.attr_data = _data.data || [];
    this.attr_data.forEach((item: any) => {
      this.attr_name_list.push(item.text);
    });
    if (item_id) {
      // 新增属性值时调用
      if (attr_value_item.parent_id) {
        // 当新增属性值时，重新给value_data赋值
        this.attr_data.forEach((item: any) => {
          if (item.id === attr_value_item.parent_id) {
            value_item.value_data = item.children;
            value_item.text = item.text;
          }
        });
        attr_value_item.id = Number(item_id);
      } else {
        value_item.id = Number(item_id);
      }
    }
    this.attr_table = generateTable(this.attr_list); // 改变属性相关字段后，重新生成明细信息
    this.setSkuAll(); // 将本地保存的明细信息重新给新的数据赋值
  }

  async addNewAttr(type: any, value_text: any, value_item: any, attr_value_item: any) {
    // type===attr_name=>属性名称，否则是属性值，value_text=>新增的属性text，value_item=>当前的属性item, attr_value_item=>属性值item
    if (!this.merchant_id || !value_text) {
      return;
    }
    const send_data = {
      merchant_id: this.merchant_id,
      text: value_text,
      parent_id: type === 'attr_value' ? value_item.id : '',
    };
    const _data = ((await this.$axios.post(API.add_attr, send_data)) || {}).data || {};
    if (_data.error) {
      this.$message.error(_data.message);
      return;
    }
    const item_id = _data.data.id;
    if (type === 'attr_value') {
      attr_value_item.text = value_text;
      attr_value_item.parent_id = value_item.id;
      this.getAttrData(item_id, value_item, attr_value_item);
      this.is_show_attr_table = true;
    } else {
      this.getAttrData(item_id, value_item, '');
    }
  }

  isShowAttrImg(value: any) {
    this.is_show_attr_img = value.target.checked;
  }

  isAttrOptionShow(option_id: number, target_list: { id: number }[], selected_id: number) {
    // 同一条属性名称下，如果选择了属性值，则当前选择的值不能出现在新增的属性值选择列表里
    return !target_list.find((item: any) => item.id === option_id) || selected_id === option_id;
  }

  onAddAttrName() {
    // 新增属性名称按钮
    const item = {
      id: undefined,
      text: undefined,
      value_list: [], // 选择的属性列表
      value_data: [], // 属性值列表
    };
    this.attr_list.push(item);
  }

  onAddAttrValue(index: any) {
    // 新增属性值按钮
    const item: any = {
      id: undefined,
      text: undefined,
      image_url: '',
      parent_id: undefined,
    };
    this.attr_list[index].value_list.push(item);
  }

  onAttrNameChange(option: any, index: any) {
    // 改变属性名称
    const item: any = {
      id: undefined,
      text: undefined,
      image_url: '',
      parent_id: undefined,
    };
    option.value_list = [item];
    this.attr_data.forEach((item: any) => {
      if (item.id === option.id) {
        this.attr_list[index].value_data = item.children;
        this.attr_list[index].text = item.text;
      }
    });
    this.attr_table = generateTable(this.attr_list); // 改变属性相关字段后，重新生成明细信息
  }

  onDeleteAttrName(index: any) {
    // 删除属性名称
    this.attr_list.splice(index, 1);
    if (this.attr_list.length > 0) {
      this.attr_table = generateTable(this.attr_list); // 改变属性相关字段后，重新生成明细信息
    } else {
      this.is_show_attr_table = false;
    }
  }

  onAttrValueChange(option: any, index: any) {
    // 改变属性值
    option.value_data.forEach((item: any) => {
      if (option.value_list[index].id === item.id) {
        option.value_list[index].text = item.text;
        option.value_list[index].parent_id = item.parent_id;
      }
    });
    this.attr_table = generateTable(this.attr_list); // 改变属性相关字段后，重新生成明细信息
    this.setSkuAll(); // 将本地保存的明细信息重新给新的数据赋值
    this.is_show_attr_table =
      this.attr_list.length > 0 && this.attr_list[0].value_list.length > 0 && this.attr_list[0].value_list[0].id > 0;
  }

  onDeleteAttrValue(item: any, index: any) {
    // 删除属性值
    item.value_list.splice(index, 1);
    this.attr_table = generateTable(this.attr_list); // 改变属性相关字段后，重新生成明细信息
    this.setSkuAll(); // 将本地保存的明细信息重新给新的数据赋值
  }

  searchAttr(value: any) {
    // 通过search事件获取到输入框里的内容
    if (!value) {
      return;
    }
    this.new_value_text = value;
  }

  blurAttrName(value_item: any) {
    // 鼠标移出输入框时，判断当前内容是否在系统里有数据，没有则添加
    const item_arr: any = [];
    this.attr_name_list.forEach((item: any) => {
      // 因为输入框带有筛选功能，为了防止出现输入了首字母，然后鼠标选择的时候，将首字母添加为属性名称
      if (item.indexOf(this.new_value_text) !== -1) {
        item_arr.push(item);
      }
    });
    this.is_add_new_attr = item_arr.length <= 0;
    if (this.attr_data.length > 0 && !this.is_add_new_attr) {
      return false;
    }
    this.is_add_new_attr = false;
    if (!value_item.id) {
      // 如果属性字段为空时，新增属性名称
      this.addNewAttr('attr_name', this.new_value_text, value_item, '');
      this.new_value_text = '';
      return;
    }
    // 如果属性字段已填充部分，新增属性名称
    let is_false: boolean = false;
    this.attr_data.forEach((item: any) => {
      if (item.text !== this.new_value_text) {
        is_false = true;
      }
    });
    if (is_false) {
      this.addNewAttr('attr_name', this.new_value_text, value_item, '');
    }
    this.new_value_text = '';
  }

  blurAttrValue(value_item: any, attr_value_item: any) {
    // 鼠标移出输入框时，判断当前内容是否在系统里有数据，没有则添加
    if (!attr_value_item.id) {
      this.addNewAttr('attr_value', this.new_value_text, value_item, attr_value_item);
    }
    this.new_value_text = '';
  }

  async created() {
    this.package_type = (storage.getItem('profile') || {}).package_type || 1;
    this.getCategoryList();
    if (this.isNew) {
      const ware_first = storage.getItem('ware_first') ? JSON.parse(storage.getItem('ware_first')) : {};
      const ware_type = ware_first.type;
      this.ware.type = ware_type[0];
      this.ware.type_secondary = ware_type[1] || 0;
      this.ware.need_express = ware_first.need_express;
    }
    this.merchant_id = (storage.getItem('profile') || {}).merchant_id || '';
    console.log(`merchant_id${this.merchant_id}`);
    const { is_app_bound, is_app_online } = await this.fetchWarePageData();
    this.is_app_bound = is_app_bound;
    this.is_app_online = is_app_online;

    await this.getAttrData('', '', '');
    if (this.isNew) {
      this.ware.guide_wechat_id = this.basis.guide_to_wx_id;
      this.ware.guide_wechat_qrcode = this.basis.guide_to_wx_qrcode;
    } else {
      await this.query();
      await this.getMerchantConfig();
      await this.getStockData();
    }

    this.field_watch_list = _.map(this.validatorMap, (validator: Validator, field: string) =>
      this.$watch(`ware.${field}`, (val: any) => {
        this.validate(field);
      })
    );
  }

  beforeDestroy() {
    this.field_watch_list.forEach((unwatch: () => void) => unwatch());
  }
}
